<template>
  <div v-show="show" id="ca-empty-state">

    <div class="circle">
      <v-icon :class="{'material-symbols-outlined': icon_outlined }" :size="icon_size">{{ icon }}</v-icon>
    </div>

    <div v-if="hayTextoPrincipal" class="texto-principal">
      {{ texto_principal }}
    </div>

    <div v-if="hayTextoSecundario" class="texto-secundario">
      {{ texto_secundario }}
    </div>

    <!-- Slot custom: para agregar texto secundario customizado -->
    <slot name="texto-secundario" class="texto-secundario"/>

  </div>
</template>

<script>

/**
 * Componente base CaEmptyState: Muestra un icono dentro de un círculo, junto con un texto principal y un texto secundario debajo.
 *
 * - Defaultea al ícono de folder
 * - En caso que no hay texto principal y/o texto secundario los mismos no se muestran.
 */
export default {
  props: {
    // Prop para mostrar o no el componente
    show: {type: Boolean, default: true},

    // Icono a mostrar
    icon: {type: String, default: 'folder'},
    icon_size: {type: Number, default: 100},
    icon_outlined: {type: Boolean, default: false},

    // Labels a mostrar
    texto_principal: {type: String, default: ''},
    texto_secundario: {type: String, default: ''},

    // Altura del componente
    height: {type: String, default: null}
  },
  computed: {

    hayTextoPrincipal() {
      return this.texto_principal.length !== 0;
    },

    hayTextoSecundario() {
      return this.texto_secundario.length !== 0;
    }
  },
  mounted() {
    if (this.height) {
      document.getElementById('ca-empty-state').style.height = this.height;
    }
  }
};
</script>

<style lang="scss">
  #ca-empty-state {
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;

    .circle {
      background: color(fondo-deshabilitado);
      width: 240px;
      height: 240px;
      border-radius: 50%;
      display: flex;
      justify-content: center;
      .v-icon {
        text-shadow: 0 2px 34px rgba(0, 0, 0, 0.12);
        color: color(blanco);
      }
    }

    .texto-principal {
      margin-top: 20px;
      font-size: 18px;
      font-weight: bold;
      color: color(gris-deshabilitado);
    }

    .texto-secundario {
      text-align: center;
      margin-top: 15px;
      font-size: 15px;
      color: color(gris-deshabilitado);
    }
  }
</style>